var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"email","placeholder":"Search...","options":_vm.users},on:{"search":_vm.onSearch},model:{value:(_vm.selectedUser),callback:function ($$v) {_vm.selectedUser=$$v},expression:"selectedUser"}},[_c('template',{slot:"no-options"},[_vm._v(" Start typing to search for a user ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }